export const environment = {
  production: false,
  // Deployed dev/test platform — mirrors Portal's and ScreenDeck's dev tier, and Chroniq's
  // own App-SPA (dev-app.chroniq.ch). Points at the already-deployed dev backend that
  // Mobile-Client's default environment.ts also uses.
  apiBaseUrl: 'https://httpfunctions-dev.azurewebsites.net',
  signalRUrl: 'https://httpfunctions-dev.azurewebsites.net/api/signalr',
  auth0Domain: 'gastro-management.eu.auth0.com',
  // "DEV Chroniq Portal-SPA" — separate Auth0 application from local/prod (see
  // environment.ts / environment.prod.ts). Only https://dev-portal.chroniq.ch is
  // registered as callback/logout/web origin.
  auth0ClientId: 'nX6BkJWeb4hno88m28NApQyxSYMoaacU',
  // Same Resource Server as local/prod — only the Auth0 application differs per environment.
  auth0Audience: 'https://api.portal.chroniq.ch',
  // Public Chroniq website (App-SPA, PUBLIC_SITE_URL in App-SPA/.env.dev). Empty hides the link.
  appSiteUrl: 'https://dev-app.chroniq.ch',
};
